import type { XY } from "../xy";
import { XYEffect } from "./xyEffect";

export class GoldPickupEffect extends XYEffect {
	static key = "GoldPickupEffect";

	constructor(
		xy: XY,
		public readonly amount: number,
	) {
		super(xy);
		this.setUnbounded(true);
	}
}
